
export enum SceneEvents {
  /**
   * Application state change events.
   */
  StartGame = 'StartGame',
  EndGame = 'EndGame',

  /**
   * Fired when a phaser scene is started.
   */
  SceneStart = 'SceneStart',

  /**
   * Go to the next position in the tour
   */
  NextPosition = 'NextPosition',

  /**
   * Go to the previous position in the tour
   */
  PrevPosition = 'PrevPosition',

  /**
   * Open an annotation modal
   */
  OpenAnnotation = 'OpenAnnotation',

  /**
   * Close an annotation modal
   */
  CloseAnnotation = 'CloseAnnotation',

  /**
   * Answer a question
   */
  AnswerQuestion = 'AnswerQuestion',

  /**
   * Select a portal to travel to a different space 
   */
  SelectPortal = 'SelectPortal',
}
